export function validateWithScroll(el: Vue, fields: string[]): boolean {
        
    /**
     * Важно чтобы поля тут располагались в том-же порядке, что и на странице.
     * Когда случится неверно заполненное поле, страница скрольнется к нему
     * и заодно покажет все неверно заполненные, которые расположены ниже
     */

    let invalid = false;
    let firstWrongField: string = null;

    for (const field of fields) {

        if (!(el.$refs[field] as any).test() as boolean) {
            invalid = true;
            if (!firstWrongField) {
                firstWrongField = field;
            }
        }
    }

    if (firstWrongField && el.$refs[firstWrongField]) {
        ((el.$refs[firstWrongField] as Vue).$el as HTMLElement).scrollIntoView({
            block: 'start',
            behavior: 'smooth',
        });
    }

    return !invalid;
}